module.exports = __webpack_public_path__ + "16f72ff4621bf9d56b22efe0a05e0fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-aranja.png
// module id = dL6W
// module chunks = 5